import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConditionsService } from '@backbase/foundation-ang/entitlements';
import { delay, filter, from, map, Observable, startWith } from 'rxjs';
import { PERMISSIONS } from '../auth/permissions';
import { FeatureFlagsAndLimitsState } from '@sbk/feature/feature-flags-and-limits';
import { Store } from '@ngrx/store';
import { loadFeatureFlagsAndLimits } from '@sbk/feature/feature-flags-and-limits';
import { selectDowntime, selectFeatureByIdentifier } from '@sbk/feature/feature-flags-and-limits';
import { LoaderService } from '@sbk/shared';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  readonly permissions = PERMISSIONS;

  downTimeType?: any;
  bannerMessage = '';
  descriptionText = '';

  isLoading$!: Observable<boolean>;

  isUniTrustPage = false;
  unitTrustStatus?: number;
  unitTrustStatusDescription?: string;

  displayNotificationSettingsButton$!: Observable<boolean>;
  whatsAppNumber = '254777068888';
  whatsAppMessage = '';

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private conditionService: ConditionsService,
    private store: Store<FeatureFlagsAndLimitsState>,
    private loadingService: LoaderService,
    private readonly route: ActivatedRoute,
    private router: Router
  ) {
    // initialize after DI is available
    this.displayNotificationSettingsButton$ = from(
      this.conditionService.resolveEntitlements(this.permissions.canViewManageNotifications),
    ).pipe(
      map((value) => Boolean(value)),
      startWith(false),
    );
  }

  ngOnInit(): void {
    this.store.dispatch(loadFeatureFlagsAndLimits());

    this.store
      .select(selectDowntime)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.downTimeType = value?.downtimeType;
        this.bannerMessage = value?.bannerMessage ?? '';
        this.descriptionText = value?.descriptionText ?? '';
      });

    this.isLoading$ = this.loadingService.loading$.pipe(delay(0));

    this.store
      .select(selectFeatureByIdentifier('UNIT_TRUSTS'))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.unitTrustStatus = value?.status;
        this.unitTrustStatusDescription = value?.message;
      });

    // set initial page flag
    this.isUniTrustPage = this.router.url.includes('invest/unit-trust');

    this.route.url?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.isUniTrustPage = this.router.url.includes('invest/unit-trust');
    });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.isUniTrustPage = this.router.url.includes('invest/unit-trust');
      });
  }

  get whatsAppLink(): string {
    const baseUrl = `https://wa.me/${this.whatsAppNumber}`;
    return this.whatsAppMessage ? `${baseUrl}?text=${encodeURIComponent(this.whatsAppMessage)}` : baseUrl;
  }
}
